import { Typography } from "@mui/material";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { resetJobs } from "@redux/jobs/actions";
import { AccountIcon, JobIcon, MailIcon, SearchFooterIcon, WishListIcon } from "@utils/svgs";
import { BACK_URL_VALUE } from "@config/constants";
import { useMySwal } from "@utils/mySwalHook";
import { PATHS } from "../config";

const Footer = ({ hasUnread, isDisable = false }) => {
  const MySwal = useMySwal();
  const dispatch = useDispatch();
  const { isAuth } = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();

  const pageIndex = [
    [PATHS.HOME],
    [PATHS.WISH_LIST],
    [
      PATHS.JOB_APPLY,
      PATHS.JOB_PLAN,
      PATHS.JOB_WORK,
      PATHS.JOB_RESULT_EMPLOYMENT,
      PATHS.JOB_RESULT_SALARY,
    ],
    [PATHS.NEW_MESSAGE, PATHS.NEWS, PATHS.MESSAGES],
    [PATHS.SETTING],
  ];
  const { pathname } = useLocation();
  const [value, setValue] = useState(null);
  const dispatchResetJobs = useCallback(() => dispatch(resetJobs()), []);

  const backBrowser = (path) =>
    pathname.includes(PATHS.JOB_DETAIL) && !searchParams.get("type") && !searchParams.get("from")
      ? BACK_URL_VALUE
      : path;

  const menus = useMemo(
    () => [
      {
        label: "検索",
        icon: <SearchFooterIcon />,
        component: Link,
        to: backBrowser(PATHS.HOME),
      },
      {
        label: "キープリスト",
        icon: <WishListIcon />,
        component: Link,
        to: PATHS.WISH_LIST,
      },
      {
        label: "お仕事管理",
        icon: <JobIcon />,
        component: Link,
        to: PATHS.JOB_APPLY,
      },
      {
        label: "メッセージ",
        icon: <MailIcon hasUnread={isAuth ? hasUnread : false} />,
        component: Link,
        to: PATHS.NEW_MESSAGE,
      },
      {
        label: "マイページ",
        icon: <AccountIcon />,
        component: Link,
        to: PATHS.SETTING,
      },
    ],
    [hasUnread, isAuth, pathname]
  );

  useEffect(() => {
    pageIndex.every((page, index) => {
      if (page.includes(pathname)) {
        setValue(index);
        return false;
      }
      setValue(-1);
      return true;
    });
  }, [pathname]);
  const handleClickBottomTab = (e) => {
    if (isDisable) {
      e.preventDefault();
      MySwal.fire({
        html: (
          <p>
            登録が完了してないため、ご利用できません。
            <br />
            まずはご登録をお願いいたします。
          </p>
        ),
        confirmButtonText: "次へ",
        allowOutsideClick: false,
      });
    }
    dispatchResetJobs();
  };

  return (
    <BottomNavigation
      showLabels
      className="jvs-bottom-bar jvs-bg-blue"
      value={value}
      onChange={(event, newValue) => {
        if (!isDisable) {
          setValue(newValue);
        }
      }}
    >
      {menus.map((menu) => (
        <BottomNavigationAction
          label={
            <Typography sx={{ color: "#fff", fontSize: "10px", wordBreak: "keep-all" }}>
              {menu.label}
            </Typography>
          }
          component={menu.component}
          to={menu.to}
          icon={menu.icon}
          key={menu.label}
          sx={{ color: "#fff", px: 1 }}
          onClick={handleClickBottomTab}
        />
      ))}
    </BottomNavigation>
  );
};

Footer.propTypes = {
  hasUnread: PropTypes.bool,
  isDisable: PropTypes.bool,
};

export default Footer;
